import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import TextArea from 'modules/core/components/TextArea'

import { ContractFlowType } from 'modules/contracts/components/FlowPage'
import FormWrapper from 'modules/contracts/components/FlowPage/FormWrapper'
import Dates from 'modules/contracts/components/FlowPage/Steps/Dates'
import { translate } from 'modules/contracts/lib/translate'

import PromotionDetailsHint from './_PromotionDetailsHint'

interface Props {
  form: Form
  translations: { [key: string]: string }
  step: number
  type: ContractFlowType
  setIsCurrentStepCompleted: (isCompleted: boolean) => void
}

const DatesAndDetails = ({ form, translations, step, type, setIsCurrentStepCompleted }: Props) => {
  const requestDetailsFields = form.get('request_details')

  const onChange = (value: string) => {
    requestDetailsFields.set(value)
  }

  const label =
    type === 'request_promote'
      ? translate(translations, 'promotion_details')
      : translate(translations, 'request_details')

  return (
    <>
      <Dates
        form={form}
        translations={translations}
        step={step}
        type={type}
        setIsCurrentStepCompleted={setIsCurrentStepCompleted}
      />
      <Box gap="s32" paddingBottom="s40">
        <FormWrapper hint={<PromotionDetailsHint />}>
          <TextArea
            label={label}
            value={requestDetailsFields.value}
            onChange={(value: string) => onChange(value)}
          />
        </FormWrapper>
      </Box>
    </>
  )
}

export default observer(DatesAndDetails)
